import api from "../api";

export const hasSignedAttachment = (attachment: api.AttachmentDetails) =>
  attachment.signed_document_status === "EXISTS";

export const isAttachmentSigned = (attachment: api.AttachmentDetails) => attachment.signature_status === "SIGNED";

export const wasSignedAttachmentDeleted = (attachment: api.AttachmentDetails) =>
  attachment.signed_document_status === "DELETED";
